import React from 'react';
import { Icons, Stack, Text, Link } from '@/theme/index';

export const VehicleReportInfoText = ({
  updatedDate,
  alertMe,
  handleMonitoringClick,
  handleRerunClick,
}: {
  updatedDate: string;
  alertMe: boolean;
  handleMonitoringClick: () => void;
  handleRerunClick: () => void;
}) => {
  return (
    <Stack direction="row" mt={2} mb={2} bgcolor="background.paper">
      <Icons.CalendarMonth fontSize="small" sx={{ color: 'secondary.dark' }} />
      <Text variant="body2" fontSize="0.9rem" data-testid="report-info">
        This vehicle history report is based on information supplied to us and
        available as of {updatedDate} . To check for updates, please{' '}
        <Text
          sx={(theme) => ({ color: theme.palette.primary.dark })}
          onClick={handleRerunClick}
          component={Link}
        >
          rerun
        </Text>{' '}
        the report or{' '}
        <Text
          sx={(theme) => ({ color: theme.palette.primary.dark })}
          onClick={handleMonitoringClick}
          component={Link}
        >
          turn {alertMe ? 'off' : 'on'} monitoring
        </Text>
        . Other information about this vehicle, such as issues relating to
        title, theft, damage or otherwise may not have been reported to us, so
        you should strongly consider a vehicle inspection, test drive and formal
        title search to make a more informed decision concerning this vehicle
        before proceeding.
      </Text>
    </Stack>
  );
};
